<template>
  <div>
    <Card>
      <template #content>
        <NewsShow v-if="news" :news="news" />
        <div class="d-flex flex-wrap justify-content-center my-5">
          <BasicButton
            label="戻る"
            variant="secondary"
            class="me-5"
            icon="pi pi-times"
            outlined
            @click="backto({ confirm: false })"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useNews, useRouterUtil, useUser } from "/@/vue/composables";
import { UserPageActions } from "/@/vue/components/Layouts";
import { Show as NewsShow } from "/@/vue/components/Molecules/News";
import { BasicButton } from "/@/vue/components/Atom";
import Card from "primevue/card";

const { getNewsItem } = useNews();
const { currentRouteParams, goto, backto } = useRouterUtil();

const id = computed(() => {
  return Number(currentRouteParams.value.id as string);
});

const { data: news } = getNewsItem(id);
</script>

<style scoped></style>
